module.exports = __webpack_public_path__ + "static/kevin-min-bf8e3d068672d78f0080afc8b60efdc0.png";